<template>
  <div class="config-list">
    <h3>全局配置</h3>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item name="1">
        <template slot="title">
          <span class="fl">试用活动状态：</span>
          <span>{{ subsidyConfig.status ? "开启" : "关闭" }}</span>
        </template>
        <el-form size="mini" class="w640" label-width="180px">
          <el-form-item label="活动结束时间">
            <el-date-picker
              v-model="subsidyConfig.endTime"
              type="date"
              placeholder="选择日期"
              format="yyyy年MM月dd日"
              value-format="yyyy年MM月dd日"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="subsidyConfig.status"
              @change="(value) => update(value, 'updateSubsidyConfig')"
            ></el-switch>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <span class="fl">发布职位入口hover状态：</span>
          <span>{{ jobHoverConfig.status ? "开启" : "关闭" }}</span>
        </template>
        <el-form size="mini" class="w640" label-width="180px">
          <el-form-item label="展示文案">
            <el-input v-model="jobHoverConfig.msg" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="jobHoverConfig.status"
              @change="(value) => update(value, 'updateJobHoverConfig')"
            ></el-switch>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <span class="fl">封号关键词：(用英文 , 分隔)</span>
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input type="textarea" v-model="sensitiveWords"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateKeyWors('sensitive_words', sensitiveWords)"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <span class="fl">警告关键词：(用英文 , 分隔)</span>
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input
              type="textarea"
              v-model="sensitivePossibleWords"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="
                updateKeyWors(
                  'sensitive_possible_words',
                  sensitivePossibleWords
                )
              "
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <span class="fl">人才主页职位推荐：(用英文 , 分隔)</span>
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input type="textarea" v-model="recommendJobs"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateRecommendJobs">确定</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template slot="title">
          <span class="fl"
            >投递简历限制：(以下工作者限制一天投递一次. 填写用户id用英文 ,
            分隔)</span
          >
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input type="textarea" v-model="changeNotes"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateKeyWors('quote_limit_list', changeNotes)"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="7">
        <template slot="title">
          <span class="fl">人才库配置</span>
        </template>
        <el-form size="mini">
          <el-form-item label="人才沟通消耗" prop="num" label-width="180px">
            <el-input
              v-model="queryParm.num"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              style="width: 460px"
            ></el-input
            ><span style="color: #606266; margin-left: 10px">颗云豆</span>
            <div class="tips-text">
              <span>(甲方与人才沟通所需消耗的云豆数量)</span>
            </div>
          </el-form-item>
          <el-form-item label="人才库广告图" class="w640" label-width="180px">
            <div class="tips-text">
              <span>(建议图片尺寸：1060*300)</span>
            </div>
            <el-upload
              class="upload-demo"
              action="https://up-z1.qbox.me/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              list-type="picture"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              accept="image/png, image/jpeg,image/bmp,image/gif,image/jpeg"
              :data="uploadData"
            >
              <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button @click="updateYunDou()">保存配置</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="8">
        <template slot="title">
          <span class="fl">身份证封禁(用英文 , 分隔)</span>
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input type="textarea" v-model="idCardBlackList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateIdCardBlackList">确定</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="9">
        <template slot="title">
          <span class="fl">乙方提现t+1白名单(用英文 , 分隔)</span>
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input type="textarea" v-model="withdrawalWhiteList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateWithdrawalList">确定</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="10">
        <template slot="title">
          <span class="fl">甲方发布工作白名单(用英文 , 分隔)</span>
        </template>
        <el-form size="mini">
          <el-form-item>
            <el-input type="textarea" v-model="publishJobWhiteList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="updatePublishJobList">确定</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import moment from "moment";
import api from "../api";
const { config } = api;

export default {
  name: "confog",
  data() {
    return {
      activeName: 1,
      jobHoverConfig: {
        msg: "",
        status: 0,
      },
      subsidyConfig: {
        endTime: "",
        startTime: "",
        status: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      sensitiveWords: "",
      sensitivePossibleWords: "",
      recommendJobs: "",
      idCardBlackList:'',
      withdrawalWhiteList: "",
      publishJobWhiteList: "",
      changeNotes: "",
      
      queryParm: {
        num: null,
        urls: [],
      },
      uploadData: {
        token: "",
        name: "",
        chunk: 0,
        chunks: 1,
      },

      fileList: [], // 原图片list
      infoList: [],
      flies: [], //
      deleteFile: [],
    };
  },
  components: {},
  computed: {},
  watch: {},
  mounted() {
    this.getConfig();
    this.getTalentConfig();
    this.getToken();
  },
  methods: {
    async getConfig() {
      let {
        data: { code, data },
      } = await config.get();
      if (code == 200) {
        this.jobHoverConfig = data.jobHoverConfig;
        this.subsidyConfig = data.subsidyConfig;
        this.jobHoverConfig.status = !!this.jobHoverConfig.status;
        this.subsidyConfig.status = !!this.subsidyConfig.status;
        this.sensitiveWords = data.sensitiveWords;
        this.sensitivePossibleWords = data.sensitivePossibleWords;
        this.recommendJobs = data.recommendJobs.length
          ? data.recommendJobs.join(",")
          : "";
          this.idCardBlackList = data.idCardBlackList.length
          ? data.idCardBlackList.join(",")
          : "";
        this.withdrawalWhiteList = this.formatList(data.withdrawalWhiteList);
        this.publishJobWhiteList = this.formatList(data.publishJobWhiteList);
        this.changeNotes = data.quoteLimitList;
      }
    },
    formatList(value) {
      if (!value) {
        return "";
      }
      return Array.isArray(value) ? value.join(",") : value;
    },
    update(value, action) {
      this[action](Number(value), action);
    },
    async updateSubsidyConfig(value, action) {
      if (value && !this.subsidyConfig.endTime) {
        this.$message.error("请填写活动结束时间");
        this.subsidyConfig.status = !value;
        return false;
      }
      if (!value) {
        this.subsidyConfig.endTime = "";
        this.subsidyConfig.startTime = "";
      } else {
        this.subsidyConfig.startTime = moment().format("YYYY年MM月DD日");
      }

      let obj = {
        endTime: this.subsidyConfig.endTime,
        startTime: this.subsidyConfig.startTime,
        status: Number(value),
      };
      let {
        data: { code, data },
      } = await config.updateSubsidyConfig(obj);
      if (code == 200) {
        this.$message.success("试用活动状态修改成功！");
      }
    },
    async updateJobHoverConfig(value, action) {
      if (value && !this.jobHoverConfig.msg) {
        this.$message.error("请填写展示文案");
        this.jobHoverConfig.status = !value;
        return false;
      }
      if (!value) {
        this.jobHoverConfig.msg = "";
      }

      let obj = {
        msg: this.jobHoverConfig.msg,
        status: Number(value),
      };
      let {
        data: { code, data },
      } = await config.updateJobHoverConfig(obj);
      if (code == 200) {
        this.$message.success("发布职位入口hover状态修改成功！");
      }
    },
    async updateKeyWors(name, value) {
      let obj = {
        name: name,
        value: value,
      };
      let {
        data: { code, data },
      } = await config.updateKeyWors(obj);
      if (code == 200) {
        // this.$message.success("关键词修改成功！");
        this.$message.success("修改成功！");
      }
    },

    

    async updateIdCardBlackList() {
      console.log(config,'config')
      if (!this.idCardBlackList) {
        this.$message.error("请填写身份证号");
        return false;
      }
      let obj = {
        ids: this.idCardBlackList.split(","),
      };
      let {
        data: { code, data },
      } = await config.updateIdCardBlackList(obj);
      if (code == 200) {
        this.$message.success("身份证封禁修改成功！");
      }
    },

    async updateWithdrawalList() {
      if (!this.withdrawalWhiteList) {
        this.$message.error("请填写乙方提现t+1白名单");
        return false;
      }
      let obj = {
        ids: this.withdrawalWhiteList.split(","),
      };
      let {
        data: { code, data },
      } = await config.updateWithdrawalList(obj);
      if (code == 200) {
        this.$message.success("乙方提现t+1白名单修改成功！");
      }
    },

    async updatePublishJobList() {
      if (!this.publishJobWhiteList) {
        this.$message.error("请填写甲方白名单发布工作");
        return false;
      }
      let obj = {
        ids: this.publishJobWhiteList.split(","),
      };
      let {
        data: { code, data },
      } = await config.updatePublishJobList(obj);
      if (code == 200) {
        this.$message.success("甲方白名单发布工作修改成功！");
      }
    },

    async updateRecommendJobs() {
      if (!this.recommendJobs) {
        this.$message.error("请填写职位id");
        return false;
      }
      let obj = {
        jobIds: this.recommendJobs.split(","),
      };
      let {
        data: { code, data },
      } = await config.updateRecommendJobs(obj);
      if (code == 200) {
        this.$message.success("推荐职位修改成功！");
      }
    },

    async getToken() {
      let res = await api.upload.token();
      if (res.data.code == 200) {
        this.uploadData.token = res.data.data.up_token;
      }
    },
    handleSuccess(res, file) {
      var url = `https:\/\/image.duiyou360.com/${res.key}`;
      // console.log(url, "上传成功--");
      this.flies.push(url);
    },
    beforeUpload(file) {
      let sizeM = file.size / 1024 / 1024;
      this.chunks = Math.ceil(sizeM / 10); // 大于10m文件进行分片
      this.uploadData.name = file.name;
      let type = [
        "image/bmp",
        "image/gif",
        "image/jpg",
        "image/jpeg",
        "image/png",
      ];

      if (type.indexOf(file.type) == -1) {
        this.$message.error("上传图片支持bmp，gif，jpg，jpeg，png格式");
        return false;
      }
    },
    handleRemove(file, fileList) {
      if (fileList && fileList.length) {
        this.flies = fileList.map((item) => {
          return item.url;
        });
      } else {
        this.flies = [];
      }
    },
    handlePreview(file) {
      console.log(file);
    },
    updateYunDou() {
      if (this.queryParm.num && this.queryParm.num > 999) {
        return this.$message.error("人才沟通消耗数量最大允许填写999");
      }
      if (this.flies && this.flies.length) {
        this.queryParm.urls = this.flies;
      }

      config.talentSave(this.queryParm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("保存成功");
          this.getTalentConfig();
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    getTalentConfig() {
      config.talentConfig().then((res) => {
        if (res.data.code === 200) {
          this.queryParm.num = res.data.data.bean_key;
          this.fileList = res.data.data.talent_carousel_key || [];
          // this.queryParm.urls = this.fileList.map((i) => i.url);
          this.flies = this.fileList.map((i) => i.url);
        } else {
          this.$message.error(res.desc);
        }
      });
    },
  },
};
</script>
<style>
.config-list {
  font-size: 14px;
}

.config-list .list {
  width: 600px;
}

.config-list .list .item {
  margin-top: -1px;
  padding: 10px 0;
  border-top: solid 1px #eee;
  border-bottom: solid 1px #eee;
}
.el-upload {
  border: none;
  display: block;
  text-align: left;
  width: auto;
  height: auto;
}
.el-upload-list--picture .el-upload-list__item-name {
  display: none;
}
.el-upload-list--picture .el-upload-list__item-thumbnail {
  /* width: 100%; */
  width: 440px !important;
  height: 100%;
  z-index: 0 !important;
}
</style>
<style scoped>
.tips-text {
  color: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/views/config/index.vue